import * as React from "react";
import { ButtonHTMLAttributes, JSX } from "react";
import "./Button.css";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
  text: string | JSX.Element;
}

export const Button = ({
  text,
  variant = "primary",
  size = "md",
  className = "",
  ...rest
}: Props) => {
  return (
    <button className={`btn btn-${variant} btn-${size} ${className}`} {...rest}>
      {text}
    </button>
  );
};
